<div class="register-container auth-container">
  <div class="register-card auth-card">
    <h2>Create Your Taptimize Account</h2>
    
    <form (ngSubmit)="onSubmit()" #registerForm="ngForm">
      <div class="form-group">
        <label for="name">Full Name</label>
        <input 
          type="text" 
          id="name" 
          name="name" 
          [(ngModel)]="registerData.name" 
          required 
          class="form-control"
          placeholder="Enter your full name">
      </div>

      <div class="form-group">
        <label for="email">Email</label>
        <input 
          type="email" 
          id="email" 
          name="email" 
          [(ngModel)]="registerData.email" 
          required 
          email
          class="form-control"
          placeholder="Enter your email">
      </div>

      <div class="form-group">
        <label for="password">Password</label>
        <input 
          type="password" 
          id="password" 
          name="password" 
          [(ngModel)]="registerData.password" 
          required
          minlength="6"
          class="form-control"
          placeholder="Enter your password (min 6 characters)">
      </div>

      <div class="error-message" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <button 
        type="submit" 
        [disabled]="!registerForm.valid || isLoading"
        class="btn-primary">
        <span *ngIf="isLoading">Creating account...</span>
        <span *ngIf="!isLoading">Create Account</span>
      </button>
    </form>

    <div class="login-link auth-link">
      <p>Already have an account? <a href="/login" (click)="goToLogin($event)">Login here</a></p>
    </div>
  </div>
</div> 